export { default as Accessible24 } from './Accessible24';
export { default as Accessible32 } from './Accessible32';
export { default as AccessibleBarrierFree } from './AccessibleBarrierFree';
export { default as Accessible } from './Accessible';
export { default as AirConditioning32 } from './AirConditioning32';
export { default as AirConditioning } from './AirConditioning';
export { default as Alert } from './Alert';
export { default as AmazonLocker } from './AmazonLocker';
export { default as ArrowDown } from './ArrowDown';
export { default as ArrowLeft } from './ArrowLeft';
export { default as ArrowRight } from './ArrowRight';
export { default as ArrowUp } from './ArrowUp';
export { default as BedTwin } from './BedTwin';
export { default as BedsideUsbCharging32 } from './BedsideUsbCharging32';
export { default as BedsideUsbCharging } from './BedsideUsbCharging';
export { default as Bell } from './Bell';
export { default as Bicycle } from './Bicycle';
export { default as BritishFlagBlackAndWhite } from './BritishFlagBlackAndWhite';
export { default as BritishFlagRegular } from './BritishFlagRegular';
export { default as BritishFlagRounded } from './BritishFlagRounded';
export { default as BurgerMenu } from './BurgerMenu';
export { default as Calendar } from './Calendar';
export { default as CancelPolicy } from './CancelPolicy';
export { default as ChangeArrows } from './ChangeArrows';
export { default as ChargedParkingEu } from './ChargedParkingEu';
export { default as ChargedParkingGb } from './ChargedParkingGb';
export { default as CheckIn } from './CheckIn';
export { default as CheckOut } from './CheckOut';
export { default as ChevronDown24 } from './ChevronDown24';
export { default as ChevronDown } from './ChevronDown';
export { default as ChevronLeft24 } from './ChevronLeft24';
export { default as ChevronLeft } from './ChevronLeft';
export { default as ChevronRight } from './ChevronRight';
export { default as ChevronUp24 } from './ChevronUp24';
export { default as ChevronUp } from './ChevronUp';
export { default as ChoiceOfPillows } from './ChoiceOfPillows';
export { default as Close } from './Close';
export { default as ComfortableArmchair32 } from './ComfortableArmchair32';
export { default as ComfortableArmchair } from './ComfortableArmchair';
export { default as CostaCoffee } from './CostaCoffee';
export { default as Desk32 } from './Desk32';
export { default as Desk } from './Desk';
export { default as DismissDarkGrey } from './DismissDarkGrey';
export { default as DismissGrey } from './DismissGrey';
export { default as Dismiss } from './Dismiss';
export { default as DoubleBed32 } from './DoubleBed32';
export { default as DoubleBed } from './DoubleBed';
export { default as Download } from './Download';
export { default as ElectricVehicleCharging } from './ElectricVehicleCharging';
export { default as Error } from './Error';
export { default as Error24 } from './Error24';
export { default as Expand } from './Expand';
export { default as ExternalLink } from './ExternalLink';
export { default as FamilyRoom } from './FamilyRoom';
export { default as FbLogo24WhiteBg } from './FbLogo24WhiteBg';
export { default as FbLogo24 } from './FbLogo24';
export { default as FbLogo32 } from './FbLogo32';
export { default as FbLogo48WhiteBg } from './FbLogo48WhiteBg';
export { default as FbLogo48 } from './FbLogo48';
export { default as FbLogoMini } from './FbLogoMini';
export { default as Filter } from './Filter';
export { default as FreeWifi32 } from './FreeWifi32';
export { default as FreeWifi } from './FreeWifi';
export { default as FreeviewTv } from './FreeviewTv';
export { default as FrenchFlagBlackAndWhite } from './FrenchFlagBlackAndWhite';
export { default as FrenchFlagRegular } from './FrenchFlagRegular';
export { default as FrenchFlagRounded } from './FrenchFlagRounded';
export { default as FullPageLoading } from './FullPageLoading';
export { default as GermanFlagBlackAndWhite } from './GermanFlagBlackAndWhite';
export { default as GermanFlagRegular } from './GermanFlagRegular';
export { default as GermanFlagRounded } from './GermanFlagRounded';
export { default as HairDryer } from './HairDryer';
export { default as HandheldShower } from './HandheldShower';
export { default as ImprovedDesk32 } from './ImprovedDesk32';
export { default as ImprovedDesk } from './ImprovedDesk';
export { default as ImprovedTeaAndCoffee32 } from './ImprovedTeaAndCoffee32';
export { default as ImprovedTeaAndCoffee } from './ImprovedTeaAndCoffee';
export { default as InRoomApp } from './InRoomApp';
export { default as Info24 } from './Info24';
export { default as Info } from './Info';
export { default as InstagramLogo24WhiteBg } from './InstagramLogo24WhiteBg';
export { default as InstagramLogo24 } from './InstagramLogo24';
export { default as InstagramLogo32WhiteBg } from './InstagramLogo32WhiteBg';
export { default as InstagramLogo32 } from './InstagramLogo32';
export { default as InstagramLogo48WhiteBg } from './InstagramLogo48WhiteBg';
export { default as InstagramLogo48 } from './InstagramLogo48';
export { default as InstagramLogoMini } from './InstagramLogoMini';
export { default as InterconnectingRooms } from './InterconnectingRooms';
export { default as Iron32 } from './Iron32';
export { default as Iron } from './Iron';
export { default as ItalianFlagBlackAndWhite } from './ItalianFlagBlackAndWhite';
export { default as ItalianFlagRegular } from './ItalianFlagRegular';
export { default as ItalianFlagRounded } from './ItalianFlagRounded';
export { default as KingBed32 } from './KingBed32';
export { default as KingBed } from './KingBed';
export { default as LanguageSelector } from './LanguageSelector';
export { default as Laundry } from './Laundry';
export { default as LiftAccess } from './LiftAccess';
export { default as Line } from './Line';
export { default as Location24 } from './Location24';
export { default as Location } from './Location';
export { default as Lock } from './Lock';
export { default as LogoHubSimple } from './LogoHubSimple';
export { default as LogoHub } from './LogoHub';
export { default as LogoPiIcon } from './LogoPiIcon';
export { default as LogoPiSimple } from './LogoPiSimple';
export { default as LogoPi } from './LogoPi';
export { default as LogoZipSimple } from './LogoZipSimple';
export { default as LogoZip } from './LogoZip';
export { default as LuggageStorage } from './LuggageStorage';
export { default as MapCompress } from './MapCompress';
export { default as MapExpand } from './MapExpand';
export { default as MastercardLogoBlackAndWhite } from './MastercardLogoBlackAndWhite';
export { default as MastercardLogo } from './MastercardLogo';
export { default as MeetingRooms } from './MeetingRooms';
export { default as MiniFridge } from './MiniFridge';
export { default as ModernRoom32 } from './ModernRoom32';
export { default as ModernRoom } from './ModernRoom';
export { default as MyBookings } from './MyBookings';
export { default as NespressoMachine32 } from './NespressoMachine32';
export { default as NespressoMachine } from './NespressoMachine';
export { default as NoOfNights } from './NoOfNights';
export { default as OneAdult } from './OneAdult';
export { default as OverheadStorage } from './OverheadStorage';
export { default as Parking } from './Parking';
export { default as Path } from './Path';
export { default as PaymentCard } from './PaymentCard';
export { default as PlayArea } from './PlayArea';
export { default as Pointer } from './Pointer';
export { default as PremierInnLogo } from './PremierInnLogo';
export { default as Price } from './Price';
export { default as Printer } from './Printer';
export { default as RainfallShower } from './RainfallShower';
export { default as Rectangle } from './Rectangle';
export { default as ResendInvoice } from './ResendInvoice';
export { default as Restaurant24 } from './Restaurant24';
export { default as Restaurant } from './Restaurant';
export { default as RoomControls } from './RoomControls';
export { default as RoundedArrowLeft } from './RoundedArrowLeft';
export { default as RoundedArrowRight } from './RoundedArrowRight';
export { default as SearchIcon } from './SearchIcon';
export { default as Security16 } from './Security16';
export { default as Security } from './Security';
export { default as SeeAll } from './SeeAll';
export { default as SelfCheckInKiosks } from './SelfCheckInKiosks';
export { default as SingleBed } from './SingleBed';
export { default as SmartTv40Inch } from './SmartTv40Inch';
export { default as Success } from './Success';
export { default as Success24 } from './Success24';
export { default as TeaAndCoffee32 } from './TeaAndCoffee32';
export { default as TeaAndCoffee } from './TeaAndCoffee';
export { default as Tick24 } from './Tick24';
export { default as Tick } from './Tick';
export { default as Timer } from './Timer';
export { default as TwitterLogo24WhiteBg } from './TwitterLogo24WhiteBg';
export { default as TwitterLogo24 } from './TwitterLogo24';
export { default as TwitterLogo32WhiteBg } from './TwitterLogo32WhiteBg';
export { default as TwitterLogo32 } from './TwitterLogo32';
export { default as TwitterLogo48WhiteBg } from './TwitterLogo48WhiteBg';
export { default as TwitterLogo48 } from './TwitterLogo48';
export { default as TwitterLogoMini } from './TwitterLogoMini';
export { default as TwoAdultsMax } from './TwoAdultsMax';
export { default as UltimateWifi32 } from './UltimateWifi32';
export { default as UltimateWifi } from './UltimateWifi';
export { default as UnderBedStorage } from './UnderBedStorage';
export { default as VanityArea } from './VanityArea';
export { default as Vending } from './Vending';
export { default as VisaLogo } from './VisaLogo';
export { default as WhiteAlert } from './WhiteAlert';
export { default as WhiteError } from './WhiteError';
export { default as WhiteInfo } from './WhiteInfo';
export { default as WhiteSuccess } from './WhiteSuccess';